import React, { useState } from 'react';
import { useWindowWidth } from '../../../helpers';
import Heading from '../../../redesign/atoms/Heading';
import { styled } from "../../../stitches.config";
import Box from '../Box';

import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

// icons 
import Arrow from "../../../redesign/assets/icons/arrow-right-white.svg"
import { ReactComponent as ArrowIcon } from "../../../redesign/assets/icons/arrow-up-icon.svg?react"

// strzałki do slidera

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <CustomArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <div />
    </CustomArrow>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <CustomArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <div />
    </CustomArrow>
  );
}

// boxy

const StaticCategory = ({ props }) => {
  const [mobileViewActive, setMobileViewActive] = useState(false)

  return <>
    <div className="row" id="top-of-category-1">
      <CategoryNav className="col-xs-12">
        <a href="#first-month" onClick={() => setMobileViewActive(true)}>1 miesiąc</a>
        <a href="#second-month" onClick={() => setMobileViewActive(true)}>2 miesiąc</a>
        <a href="#third-month" onClick={() => setMobileViewActive(true)}>3 miesiąc</a>
      </CategoryNav>
      <div className="col-xs-12" id="first-month"><Box {...props} id="b2" type="BPhotoOnTop" settings={props.settings.b2} /><Line /></div>
      <div className="col-xs-12"><Box {...props} id="b3" type="BPhotoOnLeft" settings={props.settings.b3} /><Line /></div>
      <div className="col-xs-12"><Box {...props} id="b4" type="BPhotoOnLeft" settings={props.settings.b4} /><Line /></div>
      <div className="col-xs-12"><Box {...props} id="b5" type="BPhotoOnLeft" settings={props.settings.b5} /><Line /></div>
      <div className="col-xs-12"><Box {...props} id="b6" type="BPhotoOnLeft" settings={props.settings.b6} />{mobileViewActive && <Line />}</div>
      {mobileViewActive &&
        <>
          <div className="col-xs-12" id="second-month"><Box {...props} id="b7" type="BPhotoOnTop" settings={props.settings.b7} /><Line /></div>
          <div className="col-xs-12"><Box {...props} id="b8" type="BPhotoOnLeft" settings={props.settings.b8} /><Line /></div>
          <div className="col-xs-12"><Box {...props} id="b9" type="BPhotoOnLeft" settings={props.settings.b9} /><Line /></div>
          <div className="col-xs-12"><Box {...props} id="b10" type="BPhotoOnLeft" settings={props.settings.b10} /><Line /></div>
          <div className="col-xs-12"><Box {...props} id="b11" type="BPhotoOnLeft" settings={props.settings.b11} /><Line /></div>
          <div className="col-xs-12" id="third-month"><Box {...props} id="b12" type="BPhotoOnTop" settings={props.settings.b12} /><Line /></div>
          <div className="col-xs-12"><Box {...props} id="b13" type="BPhotoOnLeft" settings={props.settings.b13} /><Line /></div>
          <div className="col-xs-12"><Box {...props} id="b14" type="BPhotoOnLeft" settings={props.settings.b14} /><Line /></div>
          <div className="col-xs-12"><Box {...props} id="b15" type="BPhotoOnLeft" settings={props.settings.b15} /><Line /></div>
          <div className="col-xs-12"><Box {...props} id="b16" type="BPhotoOnLeft" settings={props.settings.b16} /><Line /></div>
          <div className="col-xs-12"><Box {...props} id="b17" type="BPhotoOnLeft" settings={props.settings.b17} /></div>
          <ButtonScrollUp href="#top-of-category-1">DO GÓRY<span><ArrowIcon /></span></ButtonScrollUp>
        </>
      }
    </div>

    {!mobileViewActive &&
      <LinkMoreMobile onClick={() => setMobileViewActive(true)}>
        Więcej z tej kategorii
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.890625 5.01223L2.022 3.88086L7.99773 9.8566L13.9735 3.88086L15.1048 5.01223L7.99773 12.1193L0.890625 5.01223ZM13.9733 4.16387L14.8217 5.01227L7.9976 11.8364L7.99773 11.8365L14.822 5.01223L13.9735 4.1637L13.9733 4.16387ZM2.02183 4.16386L7.99744 10.1395L7.9976 10.1393L2.022 4.1637L2.02183 4.16386Z" />
        </svg>
      </LinkMoreMobile>
    }
  </>
}


const CategoryTrimester = (props) => {
  const windowWidth = useWindowWidth();
  const isDesktop = windowWidth > 996;

  const settings = {
    customPaging: function (i) {
      return (
        <a className={i === 0 || i === 5 || i === 10 ? "month" : "week"}>
          <span>{i === 0 && "1  miesiąc" || i > 0 && i < 5 && i || i === 5 && "2  miesiąc" || i > 5 && i < 10 && i - 1 || i === 10 && "3  miesiąc" || i > 10 && i - 2}</span>
        </a>
      );
    },
    infinite: true,
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1309,
        settings: {
          slidesToShow: 3,
        }
      },
    ]
  };

  return (
    <section className="container">
      <Heading title={props.settings.b1?.title_normal} showMore={false} style={'category-' + props.settings.b1?.style} />

      {isDesktop ?
        <CarouselWrapper>
          <Slider {...settings}>
            <Box {...props} id="b2" type="BTextOnPictureMini" settings={props.settings.b2} />
            <Box {...props} id="b3" type="BPhotoOnTop" settings={props.settings.b3} />
            <Box {...props} id="b4" type="BPhotoOnTop" settings={props.settings.b4} />
            <Box {...props} id="b5" type="BPhotoOnTop" settings={props.settings.b5} />
            <Box {...props} id="b6" type="BPhotoOnTop" settings={props.settings.b6} />
            <Box {...props} id="b7" type="BTextOnPictureMini" settings={props.settings.b7} />
            <Box {...props} id="b8" type="BPhotoOnTop" settings={props.settings.b8} />
            <Box {...props} id="b9" type="BPhotoOnTop" settings={props.settings.b9} />
            <Box {...props} id="b10" type="BPhotoOnTop" settings={props.settings.b10} />
            <Box {...props} id="b11" type="BPhotoOnTop" settings={props.settings.b11} />
            <Box {...props} id="b12" type="BTextOnPictureMini" settings={props.settings.b12} />
            <Box {...props} id="b13" type="BPhotoOnTop" settings={props.settings.b13} />
            <Box {...props} id="b14" type="BPhotoOnTop" settings={props.settings.b14} />
            <Box {...props} id="b15" type="BPhotoOnTop" settings={props.settings.b15} />
            <Box {...props} id="b16" type="BPhotoOnTop" settings={props.settings.b16} />
            <Box {...props} id="b17" type="BPhotoOnTop" settings={props.settings.b17} />
          </Slider>
        </CarouselWrapper> :
        <StaticCategory props={props} />
      }
    </section>
  );
};


const LinkMoreMobile = styled("button", {
  textAlign: "center",
  fontWeight: 600,
  fontSize: "18px",
  lineHeight: "24px",
  letterSpacing: "0.2px",
  color: "$primary",
  width: "100%",
  border: "0px",
  margin: "0 0 16px 0",
  background: "transparent",
  "&:hover": {
    color: "$primary120",
  },
  "&:active": {
    color: "$primary",
    textDecoration: "none",
  },
  "& svg": {
    marginLeft: "9px",
    "& path": {
      fill: "$primary",
    }
  },
});

const CategoryNav = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "-10px 0 20px 0",
  "& a": {
    color: "$grayscale100",
    cursor: "pointer",
    fontSize: "18px",
    lineHeight: "21px",
    fontWeight: 600,
    position: "relative",
    "&:hover": {
      textDecoration: "none",
      color: "$grayscale100",
      "&:before": {
        width: "4px",
        height: "4px",
        borderRadius: "4px",
        background: "$primary",
        position: "absolute",
        content: "",
        bottom: "-8px",
        left: "calc(50% - 2px)",
      }
    }
  }
});

const Line = styled("div", {
  width: "100%",
  height: "1px",
  background: "$grayscale10",
  margin: "24px 0",
});


const ButtonScrollUp = styled('a', {
  fontWeight: "800",
  color: "$grayscale0Fixed",
  background: "$grayscale100Fixed",
  borderRadius: "24px",
  borderWidth: "0px",
  padding: "4px 12px",
  display: "flex",
  cursor: "pointer",
  margin: "32px auto 24px auto",
  position: "relative",
  fontSize: "12px",
  lineHeight: "16px",
  width: "96px",
  "& svg": {
    marginLeft: "6px",
    marginBottom: "1px",
  },
})

// slider

const CustomArrow = styled("div", {
  "& div": {
    width: "48px",
    height: "48px",
    background: "$grayscale100",
    borderRadius: "48px",
    margin: "auto",
    position: "absolute",
    top: "-10px",
    left: 0,
    backgroundImage: `url("${Arrow}")`,
    backgroundPosition: "center",
    backgroundSize: "15px",
    backgroundRepeat: "no-repeat",
  }
});

const CarouselWrapper = styled("div", {
  "& .slick-slider": {
    marginTop: "130px",
  },

  "& .slick-list": {
    marginBottom: "50px",
    "@bp4": {
      marginBottom: "0px",
      padding: "10px 0px",
    },
  },
  "& .slick-slide": {
    "& > div": {
      maxWidth: "219px",
      "@bp4": {
        maxWidth: "300px",
      }
    }
  },
  "& .slick-arrow": {
    zIndex: 10,
  },
  ".slick-next": {
    right: "22px",
    top: "115px",
  },
  ".slick-prev": {
    left: "-22px",
    top: "115px",
    "& div": {
      transform: "rotate(180deg)",
    }
  },
  ".slick-dots": {
    top: "-110px",
    left: 0,
    height: "100px",
    maxWidth: "fit-content",
    bottom: 0,
    "& li": {
      position: "static",
      width: "auto",
      cursor: "auto",
      height: "auto",
      margin: 0,
      "&:nth-child(2)": {
        "& a": {
          left: 0,
        }
      },
      "&:nth-child(3)": {
        "& a": {
          left: "60px",
        }
      },
      "&:nth-child(4)": {
        "& a": {
          left: "120px",
        }
      },
      "&:nth-child(5)": {
        "& a": {
          left: "180px",
        }
      },
      "&:nth-child(7)": {
        "& a": {
          left: "240px",
        }
      },
      "&:nth-child(8)": {
        "& a": {
          left: "300px",
        }
      },
      "&:nth-child(9)": {
        "& a": {
          left: "360px",
        }
      },
      "&:nth-child(10)": {
        "& a": {
          left: "420px",
        }
      },
      "&:nth-child(12)": {
        "& a": {
          left: "480px",
        }
      },
      "&:nth-child(13)": {
        "& a": {
          left: "540px",
        }
      },
      "&:nth-child(14)": {
        "& a": {
          left: "600px",
        }
      },
      "&:nth-child(15)": {
        "& a": {
          left: "660px",
        }
      },
      "&:nth-child(16)": {
        "& a": {
          left: "720px",
        }
      },
    },
    "& a": {
      color: "$grayscale100",
      display: "block",
      transition: "0.3s",
      position: "relative",
      "&:hover": {
        textDecoration: "none",
      },
      "& span": {
        display: "block",
        fontSize: "18px",
        lineHeight: "21px",
        fontWeight: 600,
      }
    },
    "& .slick-active": {
      "& .month": {
        "&:before": {
          width: "4px",
          height: "4px",
          borderRadius: "4px",
          background: "$primary",
          position: "absolute",
          content: "",
          bottom: "-8px",
        }
      },
      "& .week": {
        backgroundColor: "$grayscale100 !important",
      }
    },
    "& .month": {
      margin: "0 56px 0 0",
      cursor: "pointer",
    },
    "& .week": {
      cursor: "pointer",
      position: "absolute",
      top: "46px",
      left: "0px",
      width: "48px",
      height: "48px",
      borderRadius: "48px",
      backgroundColor: "#B1B1B1",
      color: "$grayscale0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }
  }
});


export default CategoryTrimester;